<script>
  import ItemPerPageSelectBox from "../../../components/select/ItemPerPageSelectBox.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import MenuBar from "../../../components/menuBar/MenuBar.svelte";
  import MenuBarItem from "../../../components/menuBar/MenuBarItem.svelte";
  import PageSelector2 from "../../../components/layout/PageSelector2.svelte";
  import GeneralSelect from "../../../components/select/GeneralSelect.svelte";
  import ToggleSwitch from "../../../components/input/ToggleSwitch.svelte";
  import LeftMenuDialog from "../../../components/layout/menuDialog/variants/LeftMenuDialog.svelte";
  import MenuDialogSectionTitle from "../../../components/layout/menuDialog/MenuDialogSectionTitle.svelte";
  import MenuDialogSection from "../../../components/layout/menuDialog/MenuDialogSection.svelte";
  import MenuDialogSectionEntry from "../../../components/layout/menuDialog/MenuDialogSectionEntry.svelte";
  import GeneralButton from "../../../components/button/GeneralButton.svelte";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";
  import MenuDialogSectionEntryTitle from "../../../components/layout/menuDialog/MenuDialogSectionEntryTitle.svelte";

  import { useMyProjectPermission } from "../../../hooks/useMyProjectPermission";
  import { useInvalidateProjectQuery } from "../../../hooks/useProject";
  import { updateProjectSettings } from "../../../components/ganttchart/ganttStore/connectProjectAdminSettings";
  import { getFetchErrorHandlerContext } from "../../../hooks/useFetchErrorHandlerContext";

  /**
   * Available styles
   * @type {{
   *   name: string | null,
   *   index: number | null,
   * }[]}
   */
  export let styles;

  /**
   * Total number of pages
   * @type {number | null}
   */
  export let totalPageNumber = 1
  /**
   * Current index of the page
   */
  export let currentIndex = 0

  /**
   * @type {string}
   */
  export let projectId

  /**
   * @type {function}
   */
  export let onClickExportCsv = () => {}

  export let OperationTableStore

  const {
    EnableResultEdit,
    ItemsPerPage,
    StyleName,
    UsingCompactStyle,
  } = OperationTableStore

  const {handleNonBlockingFetchErrors} = getFetchErrorHandlerContext()
  const {invalidateProjectQuery} = useInvalidateProjectQuery()
  const {authorize} = useMyProjectPermission(projectId)

  let menuDialog
  function openMenuDialog() {
    menuDialog?.showModal()
  }
  function closeMenuDialog() {
    menuDialog?.close()
  }
</script>

<MenuBar onClickDetailedMenuOpen={openMenuDialog}>
  <svelte:fragment slot="settings">
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("asprova.terms.style")}</svelte:fragment>
      <GeneralSelect
        options={styles.map((style) => ({text: style.name, value: style.name}))}
        bind:value={$StyleName}
      />
    </MenuBarItem>
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("frontend:views.operationTable.compactVersion")}</svelte:fragment>
      <ToggleSwitch bind:on={$UsingCompactStyle}/>
    </MenuBarItem>
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("frontend:generic.itemsPerPage")}</svelte:fragment>
      <ItemPerPageSelectBox bind:value={$ItemsPerPage}/>
    </MenuBarItem>
  </svelte:fragment>
  <MenuBarItem slot="pagination">
    <PageSelector2 totalPageNumber={totalPageNumber} bind:currentIndex={currentIndex} />
  </MenuBarItem>
</MenuBar>
<LeftMenuDialog bind:dialog={menuDialog} onClose={closeMenuDialog}>
  <MenuDialogSection>
    <MenuDialogSectionTitle>
      {translate("frontend:views.operationTable.menu.export.title")}
      <HelpTooltip title={translate("frontend:views.operationTable.menu.export.tooltip.title")}>
        {translate("frontend:views.operationTable.menu.export.tooltip.caption")}
      </HelpTooltip>
    </MenuDialogSectionTitle>
    <MenuDialogSectionEntry>
      <GeneralButton buttonType="secondary" buttonFunction={onClickExportCsv}>
        {translate("frontend:views.operationTable.menu.export.buttonLabel")}
      </GeneralButton>
    </MenuDialogSectionEntry>
  </MenuDialogSection>

  <div style="margin-top:30px"/>
  <MenuDialogSection>
    <MenuDialogSectionTitle>
      {translate(
        "frontend:generic.projectAdminSettings.title"
      )}
      <HelpTooltip title={translate(
        "frontend:generic.projectAdminSettings.title"
      )}>
        {translate("frontend:generic.projectAdminSettings.tooltip")}
      </HelpTooltip>
    </MenuDialogSectionTitle>

    <div class="toggle-switch-container">
      <MenuDialogSectionEntryTitle>
        {translate("generic.editResultShort")} 
      </MenuDialogSectionEntryTitle>
      <div class="toggle-switch">
        <ToggleSwitch
          disabled={!$authorize("ProjectAdmin")}
          on={$EnableResultEdit}
          onChange={async (e) => {
            EnableResultEdit.set(e.target.checked);
            await updateProjectSettings(
              projectId,
              { isOperationTableResultEditEnabled: e.target.checked },
              handleNonBlockingFetchErrors,
              () => invalidateProjectQuery()
            );
          }}
        />
      </div>
    </div>
  </MenuDialogSection>
</LeftMenuDialog>

<style>
  .toggle-switch-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
</style>
